var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplited({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#B1B1B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 3.66669C7.40768 3.66669 3.66602 7.40835 3.66602 12C3.66602 16.5917 7.40768 20.3334 11.9993 20.3334C16.591 20.3334 20.3327 16.5917 20.3327 12C20.3327 7.40835 16.591 3.66669 11.9993 3.66669ZM15.9827 10.0834L11.2577 14.8084C11.141 14.925 10.9827 14.9917 10.816 14.9917C10.6493 14.9917 10.491 14.925 10.3743 14.8084L8.01602 12.45C7.77435 12.2084 7.77435 11.8084 8.01602 11.5667C8.25768 11.325 8.65768 11.325 8.89935 11.5667L10.816 13.4834L15.0993 9.20002C15.341 8.95835 15.741 8.95835 15.9827 9.20002C16.2243 9.44169 16.2243 9.83335 15.9827 10.0834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplited);
export default __webpack_public_path__ + "static/media/complited.0beba20704b9d73e17e4ac1f0d07b22b.svg";
export { ForwardRef as ReactComponent };